import { render } from "./GameDetailsSkeleton.vue?vue&type=template&id=3d6fba5c&scoped=true"
import script from "./GameDetailsSkeleton.vue?vue&type=script&lang=js"
export * from "./GameDetailsSkeleton.vue?vue&type=script&lang=js"

import "./GameDetailsSkeleton.vue?vue&type=style&index=0&id=3d6fba5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6fba5c"]])

export default __exports__